import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../api/api';
import { useAuth } from '../context/AuthContext';

export const PENDING_REQUEST_KEY = 'vl_pending_request';

export const readPendingRequest = () => {
  try {
    const raw = localStorage.getItem(PENDING_REQUEST_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/** Invia la richiesta compilata dalla landing appena l'utente completa registrazione o accesso. */
export const PendingRequestSubmitter = () => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const sending = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || sending.current) return;
    const pending = readPendingRequest();
    if (!pending?.payload) return;

    if (user?.role && user.role !== 'user') {
      localStorage.removeItem(PENDING_REQUEST_KEY);
      return;
    }

    sending.current = true;
    (async () => {
      try {
        const res = await api.post('/api/requests', pending.payload);
        localStorage.removeItem(PENDING_REQUEST_KEY);
        const n = res.data?.matched_professionals?.length || 0;
        toast.success(n
          ? `Richiesta inviata! ${n} professionist${n > 1 ? 'i sono stati' : 'a è stato'} contattat${n > 1 ? 'i' : 'o'}.`
          : 'Richiesta inviata! Ti ricontatteremo a breve.');
        navigate('/dashboard/richieste', { replace: true });
      } catch (err) {
        toast.error(err.response?.data?.detail || 'Non è stato possibile inviare la richiesta salvata');
        localStorage.removeItem(PENDING_REQUEST_KEY);
      } finally {
        sending.current = false;
      }
    })();
  }, [isAuthenticated, user, navigate]);

  return null;
};

export default PendingRequestSubmitter;
